import type React from "react";

interface WhatsAppGlyphProps {
  readonly className?: string;
}

export function WhatsAppGlyph({
  className,
}: WhatsAppGlyphProps): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 16.7933 16.9111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M5.62498 4.57281C5.39788 4.57281 5.18061 4.65506 5.01342 4.80885C4.46624 5.30782 3.52755 6.6149 5.07255 8.94682C5.71096 9.91058 6.56929 10.7045 7.5537 11.3089C8.70169 12.013 10.374 12.7752 11.6326 12.256C12.1201 12.0548 12.3719 11.5445 12.5113 11.0359L12.5668 10.8333C12.5668 10.5043 12.354 10.2137 12.0402 10.1127L10.7357 9.69601C10.5962 9.6531 10.4424 9.68976 10.3396 9.79258L9.90953 10.2226C9.69942 10.431 9.38112 10.481 9.11557 10.3487C8.38328 9.98209 6.98223 9.1488 6.51104 7.96323C6.42163 7.73702 6.46276 7.47774 6.61655 7.28819L7.00547 6.80269C7.09041 6.69541 7.11277 6.55325 7.06717 6.42539L6.57542 5.06994C6.46723 4.7722 6.18379 4.57281 5.8655 4.57281H5.62498Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M4.5923 15.3161C5.75462 15.9571 7.06453 16.2933 8.39666 16.2933C12.7501 16.2933 16.2933 12.7501 16.2933 8.39666C16.2933 4.0432 12.7501 0.5 8.39666 0.5C4.0432 0.5 0.5 4.0432 0.5 8.39666C0.5 9.79503 0.868374 11.1639 1.57113 12.3683L0.648138 16.163C0.611729 16.3127 0.751103 16.4456 0.898895 16.4022L4.5923 15.3161Z"
        stroke="currentColor"
      />
    </svg>
  );
}
